/**
 * This is a polyfill library that enables IE 11 to run modern websites
 * Do not use Babel as it conflicts with Google Maps API library
 */
// import "core-js/stable";
import 'regenerator-runtime/runtime';

window.Vue = require('vue').default;
import Slick from 'vue-slick-carousel'
import Toast, { POSITION } from 'vue-toastification'
import store from './store';
require('./scripts/validator');
import "vue-toastification/dist/index.css";


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */
let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
    console.error(
        "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
    );
}

Vue.use(Toast, {
  position: POSITION.TOP_RIGHT,
  maxToasts: 3,
  newestOnTop: true,
  hideProgressBar: true,
})

Vue.component('app-header', () => import('./components/Header'));
Vue.component('app-top-header', () => import('./components/TopHeader'));
Vue.component('app-page-sidebar', () => import('./components/PageSidebar'));
Vue.component('app-slideshow-services', () => import('./components/SliderServices'));
Vue.component('app-slideshow-testimonials', () => import('./components/SliderTestimonials'));
Vue.component('app-slideshow-service-gallery', () => import('./components/SliderServiceGallery'));
Vue.component('app-our-people', () => import('./components/OurPeople'));
Vue.component('app-gallery', () => import('./components/GalleryArea'));
Vue.component('app-collapsible', () => import('./components/Collapsible'));
Vue.component('app-prost-fit-classes', () => import('./components/ProstFitClasses'));
Vue.component('app-people', () => import('./components/People'));
Vue.component('video-gallery', () => import('./components/VideoGallery'));
Vue.component('events', () => import('./components/Events'));
Vue.component('support-group-meetings', () => import('./components/SupportGroupMeetings'));
Vue.component('news', () => import('./components/News'));
Vue.component('man-van-schedules', () => import('./components/ManVanSchedules'));
Vue.component('resources', () => import('./components/Resources'));
Vue.component('search', () => import('./components/Search'));
Vue.component('app-tabs', () => import('./components/Tabs'));

// Products
Vue.component('products', () => import('./components/Products/Index'));
Vue.component('stock-level-import', () => import('./components/StockLevelImport'));

// Cart

Vue.component('cart-index', () => import('./modulatte-cart/Cart.vue'));
Vue.component('cart-add-product', () => import('./modulatte-cart/components/AddToCart.vue'));
Vue.component('cart-summary', () => import('./modulatte-cart/components/Summary.vue'));
Vue.component('cart-checkout', () => import('./modulatte-cart/Checkout.vue'));

Vue.component('app-map', () => import('./components/Map'));

Vue.component('app-cart', () => import('./components/Cart'));

Vue.component('sales-report', () => import('./components/SalesReport'));
Vue.component('annual-report', () => import('./components/AnnualSalesReport'));
Vue.component('freight-prices', () => import('./components/FreightPrices'));

//add a global mixin
import ModHelpers from './mixins/ModHelpers.js';
Vue.mixin(ModHelpers);

const app = new Vue({
  el: '#app',
  components: { Slick },
  store,

  data: () => ({
    isLoaded: false,
    tab: 'east',
    faq: null,
    menu: [
      { url: '/pet-records', title: 'Pet Records' },
      { url: '/medicinal-refill', title: 'Medicinal Re-fill' },
      { url: '/services', title: 'Services' },
      { url: '/blog', title: 'Clinic News' },
      { url: '/contact', title: 'Contact Us' },
      { url: '/shop', title: 'Shop' },
      { url: '/about', title: 'About' },
      { url: '/gallery', title: 'Gallery' },
      { url: '/our-people', title: 'Our People' },
    ],
  }),

  mounted () {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.isLoaded = true
      }
    }
  },

  methods: {
    toggleTab (tab) {
      this.tab = tab
    },

    toggleFAQ (index) {
      if (index === this.faq) {
        this.faq = null
      } else {
        this.faq = index
      }
    }
  }
});
